module.exports = __webpack_public_path__ + "img/Honig-aus-2021-860.76234f96.jpg";